import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { sanitize } from "dompurify"
import { useDialogPluginComponent } from "quasar"
import { Log } from "src/util/classes/log"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { computed, onMounted, ref } from "vue"

//region Props and Emits

const undoButtonName = "undo-notification-button"


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogUndoNotification',
  props: {
  msg: {
    type: String,
    required: true,
  },

  callbackFn: {
    type: Function,
    required: true,
  },

  callbackDismissFn: {
    type: Function,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { dialogRef, onDialogOK } = useDialogPluginComponent()

const timerTick = ref<ReturnType<typeof setInterval> | undefined>()

const message = computed(() => sanitize(props.msg))

//endregion

//region Lifecycle

onMounted(() => {
  setUndoBtn()
})

//endregion

//region Functions

function setUndoBtn() {
  // Note: if you are changing the timeout, make sure to update the CSS variable as well
  const timeout = 10000 // 10 seconds
  let secondsElapsed = 1 // Start at 1 so that we ignore the first cycle. Makes it smoother.

  timerTick.value = setInterval(() => {
    const timerData = timeout / 1000 - secondsElapsed

    // Remove timer in case we somehow finish before the timeout
    if (timerData <= 0) removeTimerTick()

    secondsElapsed++

    // Get the notification action button by name
    const buttonElement = document.getElementsByName(undoButtonName)[0]

    // Somehow we couldn't find the button, no reason to keep the interval
    if (!buttonElement) {
      Log.warning({
        message: "Could not find the undo notification button",
        data: { timeout, secondsElapsed, timerData },
      })
      removeTimerTick()
    } else {
      // Update the custom CSS variable. Said variable is used in the ::afters content
      buttonElement.style.setProperty("--timer-content", timerData.toString())
    }
  }, 1000)
}

function removeTimerTick() {
  dialogRef.value?.hide()
  clearInterval(timerTick.value)
}

// This function would execute regardless the user clicking the Undo button
function dismissNotify() {
  removeTimerTick()
  if (props.callbackDismissFn) onDialogOK(props.callbackDismissFn())
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-notification",
    position: "bottom",
    html: "true",
    "no-route-dismiss": "",
    "auto-close": "",
    "no-focus": "",
    onHide: dismissNotify
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin bg-secondary text-white" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row items-center no-wrap justify-between" }, {
            default: _withCtx(() => [
              _createElementVNode("div", { innerHTML: message.value }, null, 8, _hoisted_1),
              _createVNode(_component_q_btn, {
                class: "col-auto",
                onClick: props.callbackFn,
                "icon-right": _unref(Icons).TIMED_UNDO,
                label: _ctx.$t('sfxButtons.btn_undo'),
                name: undoButtonName,
                flat: "",
                "no-caps": ""
              }, null, 8, ["onClick", "icon-right", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})